import { groq } from "next-sanity"

import { groqQueryOptions } from "./groqQueryOptions"
// TODO: edit to work with adm, regional lead, and admin users
/**
 * Helper method to retrieve an employee reference from sanity
 *
 * @param {string} employeeNumber
 * @param {SanityClient} sanityClient
 *
 * @returns Promise<{_type: string; _ref: string; _weak: boolean;}>
 */
export const getEmployeeReference = async ({ employeeNumber, sanityClient }) => {
  if (!employeeNumber) return null

  const { draftsFilter } = groqQueryOptions({ includeDrafts: true })

  const employee = await sanityClient.fetch(
    groq`*[_type=="employee" && key==$admNumber ${draftsFilter}][0] {
      "id": _id
    }`,
    { admNumber: employeeNumber },
  )

  if (!employee?.id) return null

  return {
    _type: "reference",
    _ref: employee.id,
    _weak: true,
  }
}
